export default {
	methods: {
		gFormatWind(v) {
			if (!v) return null;

			const value = v.toString();
			let res = null;

			const cut = value.replace(/[^0-9]/g, '');
			if (cut.length != 0) {
				res = (cut / 10).toFixed(
					1,
				);
			} else {
				res = '';
			}

			return value.includes('-') ? `-${res}` : res;
		},
		gFormatbestResult(v, m) {
			if (!v) return null;
			let value = v;
			/*
			d = Distanz/Gewicht/höhe
			p = Punkte
			h = Zeit, nur bis Runter auf Sekunden(1: 23: 55)
			m = Zeit "normal", mit Hundertstel(1: 23: 55, 66)
			s = Zeit mit Hunderstel, aber nur Sekunden auch bei > 60 Sekunden.Z.b. 90, 33(anstatt 1: 30, 33)
			*/
			let isWeight; let isEndurance; let isNormal; let
				isSprint; let isPoints;
			isWeight = isPoints = isEndurance = isNormal = isSprint = false;
			let handTime = false;
			switch (m) {
			case 'd':
				isWeight = true;
				break;
			case 'p':
				isPoints = true;
				break;
			case 'h':
				isEndurance = true;
				break;
			case 'm':
				handTime = v.includes('*');
				isNormal = true;
				break;
			case 's':
				handTime = v.includes('*');
				isSprint = true;
				break;
			default:
			}
			if (value) {
				if (value == 'x'){
					value = '0.0';
				}
				value = value.toString().replace(/^[0]+|[^0-9]/g, '');
				if (handTime) value += '0';
				if (value != '') {
					if (isEndurance || isNormal) {
						if (value.length === 1 || value.length % 2 !== 0) {
							value = `0${value}`;
						}
						const pairs = value.match(/.{1,2}/g);
						if (pairs.length === 1) {
							value = `00:${pairs[0]}`;
						} else if (pairs.length > 3) {
							value = pairs
								.slice(0, pairs.length - 2)
								.join('')
								.replace(/^[0]+/g, '');
							value += `:${pairs.slice(pairs.length - 2).join(':')}`;
						} else {
							value = pairs.join(':');
						}
						const i = value.lastIndexOf(':');
						if (i != -1 && isNormal) value = `${value.substr(0, i)}.${value.substr(i + 1)}`;
					} else if (isWeight || isSprint) {
						value = (value / 100).toFixed(2);
					} else if (isPoints) {
						value = (value * 1).toFixed(0);
					}
				}
				if (handTime) {
					value = value.replace(/.$/, '*');
				}
				return value;
			}
			return '';
		},
		gFormatDate(date) {
			return date
				? this.$moment(date).format('DD.MM.YYYY')
				: '';
		},
	},
};
